import React from 'react';
import {
  CalendarToday,
  LocationOn,
  People,
  LocalCafe,
  Restaurant,
  Favorite
} from '@mui/icons-material';
import EventLayout from '../../components/events/EventLayout';
import BackButton from '../../components/events/BackButton';
import EventHero from '../../components/events/EventHero';
import ImageCarousel from '../../components/events/ImageCarousel';
import EventMeta from '../../components/events/EventMeta';
import KeyTakeaways from '../../components/events/KeyTakeaways';

const Chalets2024 = () => {
  const eventData = {
    title: 'Taking Control of the Chalets de l\'Avent!',
    category: 'Social Event',
    date: '12/11/2024',
    location: 'EPFL Esplanade',
    description: 'We had the pleasure of hosting a wonderful evening at the Chalets de l\'Avent on EPFL\'s Esplanade. Our stand became a festive gathering spot where the EPFL community came together to enjoy traditional treats and warm drinks, creating a truly magical winter atmosphere.',
    media: [
      { src: "/events/chalets24/chalets1.jpeg", objectFit: 'cover', objectPosition: '50% 65%' }
    ],
    keyTakeaways: [
      {
        icon: <People style={{ fontSize: '24px' }} />,
        title: 'Amazing Turnout',
        description: 'More than 200 people visited our stand, making it one of the most popular Chalets de l\'Avent events of the season.',
        color: '#4F8EF7'
      },
      {
        icon: <Restaurant style={{ fontSize: '24px' }} />,
        title: 'Traditional Treats',
        description: 'We distributed over 150 free traditional "suvganiotes" (Israeli-style beignets), bringing a taste of Israeli culture to EPFL.',
        color: '#9C88FF'
      },
      {
        icon: <LocalCafe style={{ fontSize: '24px' }} />,
        title: 'Warming Hearts',
        description: 'Hot chocolate and sugar candy were served to keep everyone warm and sweet during the chilly evening.',
        color: '#50E3C2'
      },
      {
        icon: <Favorite style={{ fontSize: '24px' }} />,
        title: 'Community Spirit',
        description: 'The event successfully brought together students, faculty, and staff, fostering a warm and welcoming atmosphere.',
        color: '#FF6B9D'
      }
    ]
  };

  const metaItems = [
    {
      icon: <CalendarToday style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #4F8EF7, #9C88FF)',
      title: 'December 11, 2024',
      subtitle: 'Event Date'
    },
    {
      icon: <LocationOn style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #50E3C2, #4DD0E1)',
      title: eventData.location,
      subtitle: 'Location'
    },
    {
      icon: <People style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #FF6B9D, #FF8A65)',
      title: '200+ Visitors',
      subtitle: 'Attendance'
    }
  ];

  return (
    <EventLayout>
      <BackButton />
      <EventHero
        category={eventData.category}
        title={eventData.title}
        description={eventData.description}
      >
        <EventMeta items={metaItems} />
      </EventHero>

      <ImageCarousel
        media={eventData.media}
        interval={4000}
      />

      <KeyTakeaways items={eventData.keyTakeaways} />

      <div style={{
        background: 'white',
        border: '1px solid rgba(0,0,0,0.1)',
        borderRadius: '12px',
        padding: '40px',
        marginTop: '40px',
        marginBottom: '60px',
        textAlign: 'center'
      }}>
        <h3 style={{
          fontFamily: 'var(--font-serif)',
          fontSize: '1.5rem',
          color: 'var(--color-text)',
          marginBottom: '16px'
        }}>
          Thank You!
        </h3>
        <p style={{
          fontSize: '1rem',
          color: 'var(--color-text-light)',
          lineHeight: '1.6',
          maxWidth: '800px',
          margin: '0 auto'
        }}>
          We're grateful to everyone who joined us at the Chalets de l'Avent. Your presence and enthusiasm made this evening truly memorable. Special thanks to all our volunteers who helped serve treats and create such a welcoming atmosphere!
        </p>
      </div>
    </EventLayout>
  );
};

export default Chalets2024;